export const formSearchHistoryErrors = {
    search: [
        {
            code: 'maxLength',
            message: 'Search must be no longer than 50 characters',
        },
        {
            code: 'preventedHTMLStr',
            message: 'Please enter a valid value',
        },
    ],
};
